module.exports = __webpack_public_path__ + "img/52.224f5d81.png";